/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { Grid, Radio, Tooltip, Typography } from '@mui/material';

const RadioButtonsGroup = (props) => {
  const { handleChangeInput, roInputDetails, blurInputval,
    handleChangeRecovery, recovery, setRoRadioABFactor, roRadioABFactor, setIsShowErrorMessage,
    isOptnAbValFctrToggled, setIsOptnAbValFctrToggled, translateObject, roDetails, setOpenRoForm } = props;

  const { splitPermeate } = roInputDetails;
  const units = JSON.parse(localStorage.getItem('system-units')) || {};

  function getUnitValue(value) {
    return units.flow || value;
  };

  const handleChangeABFactor = (event) => {
    setIsOptnAbValFctrToggled(!isOptnAbValFctrToggled); // for abValue close issue false tha
    setRoRadioABFactor(event.target.value);
    setIsShowErrorMessage(true);
    setOpenRoForm(true);
  };

  return (
    <Grid container spacing={1} style={{ 'marginTop': 0 }}>
      <Grid item xs={4} md={4} sm={12} className="radio-input-combined" style={{ display: 'block' }}>
        <Grid item xs={12} md={12} sm={12} className='split-permeate' style={{ marginBottom: 5 }}>
          <div className='field-text no_drag S_Bold' style={{ marginRight: 8, width: 230 }}>{translateObject('Array Recovery')}, %</div> { /* RO Recovery -> Array Recovery : by Abhishek: 16-Nov-23 */}
          <input
            // hiddenLabel
            id="filled-hidden-label-small"
            variant="outlined"
            onChange={handleChangeRecovery}
            onFocus={e => e.target.select()}
            className="Form_Input_design combined-input-field no_drag"
            style={{ paddingLeft: '16px' }}
            type="number"
            name="recovery"
            value={roDetails.type === 'customnode_productOut' ? '' : recovery}
            disabled={roDetails.type === 'customnode_productOut'}
          />
        </Grid>
        <Grid item xs={12} md={12} sm={12} className='split-permeate'>
          <div className='field-text no_drag S_Bold' style={{ marginRight: 8, width: 230 }}>{translateObject('Split Permeate (Upstream Part)')}, {getUnitValue('gpm')}</div>
          <input
            // hiddenLabel
            id="filled-hidden-label-small"
            variant="outlined"
            onChange={handleChangeInput}
            onBlur={blurInputval}
            onFocus={e => e.target.select()}
            className="Form_Input_design combined-input-field no_drag"
            style={{ paddingLeft: '16px' }}
            type="number"
            name="splitPermeate"
            value={splitPermeate}
          />
        </Grid>

      </Grid>
      <Grid item xs={8} className='radio-group'>
        <div className='no_drag factor-wrapper'>
          <div className='annual-ele' style={{ marginRight: 16 }}>
            <Radio
              checked={roRadioABFactor === '0'}
              onChange={handleChangeABFactor}
              value="0"
              name="radio-buttons"
            />
            <label className='ro-radio-text no_drag S_Regular'>{translateObject('Use Element Age and Annual % Change')}</label>
          </div>
          <div className='annual-ele'>
            <Radio
              checked={roRadioABFactor === '1'}
              onChange={handleChangeABFactor}
              value="1"
              name="radio-buttons"
            />
            <Tooltip
              title={
                <Grid container>
                  <Grid item xs={12} style={{ 'borderBottom': '0.5px solid #F2F2F2' }}>
                    <Grid container style={{ 'display': 'flex', 'alignItems': 'center' }}>
                      <Grid item xs={3} style={{ 'display': 'flex', 'flexDirection': 'column', 'alignItems': 'center' }}>
                        <Typography color="inherit" style={{ 'fontSize': '16px' }}>A</Typography>
                        <Typography color="inherit" style={{ 'fontSize': '12px' }}>0.5 - 1</Typography>
                      </Grid>
                      <Grid item xs={9} style={{ 'fontFamily': 'sans W4SeLig !important', 'fontSize': '10px' }}>
                        {translateObject('0.5 Means that the elements only gives half the permeate flow rate as of the nominal element')}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container style={{ 'display': 'flex', 'align-items': 'center' }}>
                      <Grid item xs={3} style={{ 'display': 'flex', 'flex-direction': 'column', 'align-items': 'center' }}>
                        <Typography color="inherit" style={{ 'font-size': '16px' }}>B</Typography>
                        <Typography color="inherit" style={{ 'font-size': '12px' }}>1 - 1.5</Typography>
                      </Grid>
                      <Grid item xs={9} style={{ 'font-family': 'sans W4SeLig !important', 'font-size': '10px' }}>
                        {translateObject('1.5 means that the salt passage is 1.5 times higher than that of the nominal element')}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              } placement="top">
              <label className='ro-radio-text no_drag S_Regular'>{translateObject('Input A Value Factor & B Value Factor')}</label>
            </Tooltip>
          </div>
        </div>
      </Grid>
    </Grid >
  );
};

export default RadioButtonsGroup;
